import { Component, Input, OnChanges, ViewChild, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { PatchRow } from '../../../../models/patch-management.models';

const SEV_CLASS: Record<string, string> = {
  Critical: 'critical',
  Important: 'important',
  Moderate: 'moderate',
  Low: 'low',
  Unrated: 'unrated',
};

@Component({
  selector: 'app-patch-details-table',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatSortModule, MatPaginatorModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './patch-details-table.component.html',
  styleUrls: ['./patch-details-table.component.scss'],
})
export class PatchDetailsTableComponent implements OnChanges, AfterViewInit {
  @Input({ required: true }) patches: PatchRow[] = [];
  @Input() selectedDevice: string | null = null;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  displayedColumns: string[] = [
    'computer',
    'kbNumber',
    'severity',
    'installStatus',
    'deploymentStatus',
    'patchName',
    'patchType',
    'os',
    'releaseDate',
  ];
  dataSource = new MatTableDataSource<PatchRow>([]);

  ngOnChanges(): void {
    this.dataSource.data = this.selectedDevice
      ? this.patches.filter((p) => p.computer === this.selectedDevice)
      : this.patches;
    this.paginator?.firstPage();
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  sevClass(sev: string): string {
    return SEV_CLASS[sev] ?? 'unrated';
  }
}
